import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AdminAlert } from '../../../models/site-review/admin-alert.model';
import { AlertService } from 'app/services/alert.service';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: false,
})
export class AlertDialogComponent {
  safeHtml: SafeHtml;
  constructor(@Inject(MAT_DIALOG_DATA) public data: AdminAlert, sanitizer: DomSanitizer, private service: AlertService) {
    // Trusts the preview; sanitize on the server when storing/rendering to users.
    this.safeHtml = sanitizer.bypassSecurityTrustHtml(data.contents ?? '');
  }

  acknowledgeAlert() {
    //console.log('Acknowledging alert', this.data);
    if (!this.data.dashAlertID) return;
    this.service.acknowledgement(this.data.dashAlertID).subscribe({
      next: () => {
        // On success, close dialog
      },
      error: (err) => {
        console.error('Error acknowledging alert:', err);
      }
    });
  }
}

